import Repository from '../axios'
import {defaultPagination} from "../constants/config";
import staff from "../apis/staff";

const  resource = "/supplier";
const  resource_new = "/customer";
export default {
  updateStaffPassword(payload){
    return Repository.post(`${resource_new}/change-password`, payload)
  },
  accountVerify(code) {
    return Repository.get(`${resource_new}/verify/${code}`)
  },
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource_new}/users?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  createSupplierUser(payload) {
    return Repository.post(`${resource_new}/users`, payload)
  },
  getSupplierUser(id){
    return Repository.get(`${resource_new}/users/${id}`)
  },
  updateSupplierUser(id, payload){
    return Repository.put(`${resource_new}/users/${id}`, payload)
  },
  updateSupplierBasicDetails(payload){
    return Repository.put(`${resource_new}/customers`, payload)
  },
  getBasicSupplierDetails() {
    return Repository.get(`${resource_new}/customers/get-details`)
  },
  uploadFile(file) {
    console.log(file)
    return Repository.post(`${resource_new}/file-upload`, file, {headers: {
        'Content-Type': 'multipart/form-data'
      }})
  },
  getManufactureSiteStatus(id) {
    return Repository.get(`${resource}/saq/manufacture/get-status/${id}`)
  },
  forgotPassword(payload) {
    return Repository.post(`${resource_new}/forgot-password`, payload)
  },
  getForgotPasswordToken(token){
    return Repository.get(`${resource_new}/forgot-password/${token}`)
  },
  passwordReset(payload){
    return Repository.post(`${resource_new}/reset-password`, payload)
  },
  customerUserWelcomeEmailResend(email) {
    return Repository.put(`${resource_new}/${email}/customer-user-resend`)
  },
  changeCustomerUserStatus(id, status) {
    return Repository.put(`${resource_new}/users/${id}/${status}`)
  },
  getCustomerSites(pageNumber = 1, filterQuery, pagination = defaultPagination, sort){
    return Repository.get(`${resource_new}/sites?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  createCustomerSite(payload) {
    return Repository.post(`${resource_new}/sites`, payload)
  },
  updateCustomerSite(id, payload) {
    return Repository.put(`${resource_new}/sites/${id}`, payload)
  },
  getCustomerSiteDetails(id){
    return Repository.get(`${resource_new}/sites/${id}`)
  },
};
